import { Anchor, Container, Text } from "@mantine/core";
import { IconArrowRight, IconFlask2, IconStethoscope } from "@tabler/icons-react";

type NextGenService = "diagnostics" | "medical";

export function ServiceSwitcher({ active }: { active: NextGenService }) {
  const isDiagnostics = active === "diagnostics";
  const Icon = isDiagnostics ? IconStethoscope : IconFlask2;

  return (
    <aside
      className="service-switcher-shell"
      data-from={active}
      aria-label="Other NextGen services"
    >
      <Container className="service-switcher" size="xl">
        <div className="service-switcher-prompt">
          <span className="service-switcher-icon" aria-hidden="true">
            <Icon size={22} stroke={1.9} />
          </span>
          <Text>
            <small>{isDiagnostics ? "Looking for a doctor?" : "Looking for laboratory testing?"}</small>
            <strong>
              {isDiagnostics ? "Visit NextGen Medical" : "Go to NextGen Diagnostics"}
            </strong>
          </Text>
        </div>
        <div className="service-switcher-actions">
          <Anchor className="service-switcher-all" href="/">
            View both services
          </Anchor>
          <Anchor
            className="service-switcher-option"
            href={isDiagnostics ? "/medical" : "/diagnostics"}
          >
            {isDiagnostics ? "Explore medical care" : "Explore laboratory services"}
            <IconArrowRight size={18} aria-hidden="true" />
          </Anchor>
        </div>
      </Container>
    </aside>
  );
}
